module.exports = Promise.all([parcelRequire.load("7tSlc"), parcelRequire.load("gYf19"), parcelRequire.load("6hT7h")]).then(() => parcelRequire('fuJFP'));